import nextDynamic from 'next/dynamic';

const Content = nextDynamic(() => import('./profile-content'), { ssr: false });

export default function Page() {
  return <Content />;
}
